import React, { lazy, createElement, Suspense } from 'react'
import type { IMenuList } from './type'
import * as httpSettings from '@/config/httpSettings'
import {
  CreditCardOutlined,
  LineChartOutlined,
  NodeIndexOutlined,
  ScheduleOutlined,
  SettingOutlined,
  CloudOutlined,
  BarChartOutlined,
  HistoryOutlined,
  DotChartOutlined,
  PayCircleOutlined,
  TeamOutlined
  // QuestionCircleOutlined
} from '@ant-design/icons'
import { Spin } from 'antd'
// import { Spin, Tooltip } from 'antd'

const createLazyElement = (ele: () => Promise<{ default: React.FC }>) => {
  return (
    <Suspense
      fallback={
        <Spin
          size="large"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}
        />
      }
    >
      {createElement(lazy(ele))}
    </Suspense>
  )
}

const createLazyElementWithProps = (ele: () => Promise<{ default: React.ComponentType<any> }>, props: any) => {
  const LazyComponent = lazy(ele)
  return (
    <Suspense
      fallback={
        <Spin
          size="large"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
          }}
        />
      }
    >
      {createElement(LazyComponent, props)}
    </Suspense>
  )
}

export const menuList: IMenuList[] = [
  {
    index: true,
    layout: false,
    menu: false,
    id: 'login',
    path: httpSettings.loginUrl.startsWith('/') ? httpSettings.loginUrl.slice(1) : httpSettings.loginUrl,
    element: createLazyElement(async () => await import('@/pages/Login')),
    name: 'login'
  },
  {
    layout: false,
    menu: false,
    id: 'trial',
    path: '/user/trial',
    element: createLazyElement(async () => await import('@/pages/Trial')),
    name: 'trial'
  },
  {
    layout: false,
    menu: false,
    id: 'trialSuccess',
    path: '/user/trialSuccess',
    element: createLazyElement(async () => await import('@/pages/TrialSuccess')),
    name: 'trialSuccess'
  },
  {
    id: 'bankCardSourceData',
    path: 'bankCardSourceData',
    name: '卡证数据源',
    icon: <CreditCardOutlined />
  },
  {
    id: 'highRiskBankCard',
    path: 'highRiskBankCard',
    parentId: 'bankCardSourceData',
    element: createLazyElement(async () => await import('@/pages/HighRiskBankCard')),
    name: '高危卡号',
    // icon: <AppstoreOutlined />,
    breadCrumb: [
      {
        title: '卡证数据源 / 高危卡号',
        href: `${BASE_PATH}/highRiskBankCard`
      }
    ]
  },
  {
    id: 'bankcardOriginalMessage',
    path: 'highRiskBankCard/message',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/HighRiskBankCard/message')),
    name: '原始消息'
  },
  {
    id: 'highRiskIdentityCards',
    path: 'highRiskIdentityCards',
    parentId: 'bankCardSourceData',
    element: createLazyElement(async () => await import('@/pages/HighRiskIdentityCards')),
    name: '高危身份证',
    // icon: <SettingOutlined />,
    breadCrumb: [
      // {
      //   title: '银行卡源数据',
      //   href: `${BASE_PATH}/bankCardSourceData`
      // },
      {
        title: '卡证数据源 / 高危身份证',
        href: `${BASE_PATH}/highRiskIdentityCards`
      }
    ]
  },
  {
    id: 'idcardOriginalMessage',
    path: 'highRiskIdentityCards/message',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/HighRiskIdentityCards/message')),
    name: '原始消息'
  },
  // {
  //   id: 'accountDetails',
  //   path: 'accountDetails',
  //   parentId: 'bankCardSourceData',
  //   element: createLazyElement(async () => await import('@/pages/AccountDetails')),
  //   name: '账户详情信息',
  //   // icon: <SettingOutlined />,
  //   breadCrumb: [
  //     // {
  //     //   title: '银行卡源数据',
  //     //   href: `${BASE_PATH}/accountDetails`
  //     // },
  //     {
  //       title: '卡证数据源 / 账户详情信息',
  //       href: `${BASE_PATH}/highRiskIdentityCards`
  //     }
  //   ]
  // },
  {
    id: 'transferReceiptInformation',
    path: 'transferReceiptInformation',
    parentId: 'bankCardSourceData',
    element: createLazyElement(async () => await import('@/pages/TransferReceiptInformation')),
    name: '转账详情',
    // icon: <SettingOutlined />,
    breadCrumb: [
      // {
      //   title: '银行卡源数据',
      //   href: `${BASE_PATH}/transferReceiptInformation`
      // },
      {
        title: '卡证数据源 / 转账详情',
        href: `${BASE_PATH}/highRiskIdentityCards`
      }
    ]
  },
  {
    id: 'transferreceiptOriginalMessage',
    path: 'transferReceiptInformation/message',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/TransferReceiptInformation/message')),
    name: '原始消息'
  },
  {
    id: 'corporateAccount',
    path: 'corporateAccount',
    parentId: 'bankCardSourceData',
    element: createLazyElement(async () => await import('@/pages/CorporateAccount')),
    name: '对公账户',
    breadCrumb: [
      {
        title: '卡证数据源 / 对公账户',
        href: `${BASE_PATH}/corporateAccount`
      }
    ]
  },
  {
    id: 'corporateAccountOriginalMessage',
    path: 'corporateAccount/message',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/CorporateAccount/message')),
    name: '原始消息'
  },
  {
    id: 'retrieveIntelligence',
    path: 'retrieveIntelligence',
    element: createLazyElement(async () => await import('@/pages/RetrieveIntelligence')),
    name: '取现情报',
    icon: <PayCircleOutlined />,
    breadCrumb: [
      {
        title: '取现情报',
        href: `${BASE_PATH}/retrieveIntelligence`
      }
    ]
  },
  {
    id: 'supplyTrend',
    path: 'supplyTrend',
    name: '供数趋势',
    icon: <LineChartOutlined />
  },
  {
    id: 'highRiskBC',
    path: 'highRiskBC',
    parentId: 'supplyTrend',
    element: createLazyElement(async () => await import('@/pages/SupplyTrend/highRiskBC')),
    name: '高危卡号',
    breadCrumb: [
      {
        title: '供数趋势 / 高危卡号',
        href: `${BASE_PATH}/SupplyTrend/highRiskBC`
      }
    ]
  },
  {
    id: 'transferDetails',
    path: 'transferDetails',
    parentId: 'supplyTrend',
    element: createLazyElement(async () => await import('@/pages/SupplyTrend/transferDetails')),
    name: '转账详情',
    breadCrumb: [
      {
        title: '供数趋势 / 转账详情',
        href: `${BASE_PATH}/SupplyTrend/transferDetails`
      }
    ]
  },
  {
    id: 'bankCardActivityField',
    path: 'bankCardActivityField',
    name: '活跃指数',
    icon: <DotChartOutlined />
  },
  {
    id: 'bankCardActivityFieldTrend',
    path: 'bankCardActivityFieldTrend',
    parentId: 'bankCardActivityField',
    element: createLazyElement(async () => await import('@/pages/BankCardActivityIndex')),
    name: '趋势分析',
    breadCrumb: [
      {
        title: '活跃指数 / 趋势分析',
        href: `${BASE_PATH}/BankCardActivityField/trend`
      }
    ]
  },
  {
    id: 'bankCardActivityFieldRegional',
    path: 'bankCardActivityFieldRegional',
    parentId: 'bankCardActivityField',
    element: createLazyElement(async () => await import('@/pages/BankCardActivityField/regional')),
    name: '地域洞察',
    breadCrumb: [
      {
        title: '活跃指数 / 地域洞察',
        href: `${BASE_PATH}/BankCardActivityField/regional`
      }
    ]
  },
  {
    id: 'hotWord',
    path: 'hotWord',
    element: createLazyElement(async () => await import('@/pages/HotWord')),
    name: '热词云图',
    icon: <CloudOutlined />,
    breadCrumb: [
      {
        title: '热词云图',
        href: `${BASE_PATH}/hotWord`
      }
    ]
  },
  {
    id: 'bankPriceTrend',
    path: 'bankPriceTrend',
    name: '银行卡价格趋势',
    icon: <BarChartOutlined />
  },
  {
    id: 'currBankPriceTrend',
    path: 'currBankPriceTrend',
    parentId: 'bankPriceTrend',
    element: createLazyElement(async () => await import('@/pages/CurrBankPriceTrend')),
    name: '本行价格动态',
    breadCrumb: [
      {
        title: '银行卡价格趋势 / 本行价格动态',
        href: `${BASE_PATH}/currBankPriceTrend`
      }
    ]
  },
  {
    id: 'marketPriceOverview',
    path: 'marketPriceOverview',
    parentId: 'bankPriceTrend',
    element: createLazyElement(async () => await import('@/pages/MarketPriceOverview')),
    name: '市场价格总览',
    breadCrumb: [
      {
        title: '银行卡价格趋势 / 市场价格总览',
        href: `${BASE_PATH}/marketPriceOverview`
      }
    ]
  },
  // {
  //   id: 'provincesRanking',
  //   path: 'provincesRanking',
  //   name: '省份排名',
  //   icon: <BarChartOutlined />
  // },
  // {
  //   id: 'provinceRanking',
  //   path: 'provinceRanking',
  //   parentId: 'provincesRanking',
  //   element: createLazyElement(async () => await import('@/pages/ProvinceRanking')),
  //   name: '省份排名',
  //   breadCrumb: [
  //     {
  //       title: '省份排名 / 省份排名',
  //       href: `${BASE_PATH}/provinceRanking`
  //     }
  //   ]
  // },
  // {
  //   id: 'beijingRanking',
  //   path: 'beijingRanking',
  //   parentId: 'provincesRanking',
  //   element: createLazyElement(async () => await import('@/pages/BeijingRanking')),
  //   name: '北京排名',
  //   breadCrumb: [
  //     {
  //       title: '省份排名 / 北京排名',
  //       href: `${BASE_PATH}/beijingRanking`
  //     }
  //   ]
  // },
  {
    id: 'intelligenceLeads',
    path: 'intelligenceLeads',
    // element: createLazyElement(async () => await import('@/pages/IntelligenceLeads/new')),
    name: '情报线索',
    icon: <NodeIndexOutlined />
    // breadCrumb: [
    //   {
    //     title: '情报线索',
    //     href: `${BASE_PATH}/intelligenceLeads`
    //   }
    // ]
  },
  {
    id: 'attackIntelligence',
    path: 'attackIntelligence',
    parentId: 'intelligenceLeads',
    element: createLazyElement(async () => await import('@/pages/AttackIntelligence')),
    name: '攻击情报',
    breadCrumb: [
      {
        title: '情报线索 / 攻击情报',
        href: `${BASE_PATH}/attackIntelligence`
      }
    ]
  },
  {
    id: 'industryThinkTank',
    path: 'industryThinkTank',
    parentId: 'intelligenceLeads',
    element: createLazyElement(async () => await import('@/pages/IndustryThinkTank')),
    name: '行业智库',
    breadCrumb: [
      {
        title: '情报线索 / 行业智库',
        href: `${BASE_PATH}/industryThinkTank`
      }
    ]
  },
  {
    id: 'insight',
    path: 'insight',
    parentId: 'intelligenceLeads',
    element: createLazyElement(async () => await import('@/pages/Insight')),
    name: '洞见',
    breadCrumb: [
      {
        title: '情报线索 / 洞见',
        href: `${BASE_PATH}/insight`
      }
    ]
  },

  {
    id: 'informationConfiguration',
    path: 'informationConfiguration',
    name: '信息配置',
    icon: <SettingOutlined />
  },
  {
    id: 'bankCardIssuance',
    path: 'bankCardIssuance',
    parentId: 'informationConfiguration',
    element: createLazyElement(async () => await import('@/pages/BankCardIssuance')),
    name: '银行发卡量配置',
    breadCrumb: [
      // {
      //   title: '信息配置',
      //   href: `${BASE_PATH}/informationConfiguration`
      // },
      {
        title: '信息配置 / 银行发卡量配置',
        href: `${BASE_PATH}/bankCardIssuance`
      }
    ]
  },
  {
    id: 'VersionReleaseConfig',
    path: 'versionReleaseConfig',
    parentId: 'informationConfiguration',
    name: '版本发布配置',
    element: createLazyElement(async () => await import('@/pages/VersionReleaseConfig')),
    permission: ['OY管理员'],
    breadCrumb: [
      {
        title: '信息配置 / 版本发布配置',
        href: `${BASE_PATH}/versionReleaseConfig`
      }
    ]
  },
  {
    id: 'addArticles',
    path: 'addArticles',
    name: '新增文章',
    menu: false,
    element: createLazyElement(async () => await import('@/pages/ArticlePublished/addArticles'))
  },
  // {
  //   id: 'hotWordConfiguration',
  //   path: 'hotWordConfiguration',
  //   parentId: 'informationConfiguration',
  //   element: createLazyElement(async () => await import('@/pages/HotWordConfiguration')),
  //   name: '热词配置',
  //   breadCrumb: [
  //     {
  //       title: '信息配置',
  //       href: `${BASE_PATH}/informationConfiguration`
  //     },
  //     {
  //       title: '热词配置',
  //       href: `${BASE_PATH}/hotWordConfiguration`
  //     }
  //   ]
  // },
  {
    id: 'articlePublished',
    path: 'articlePublished',
    parentId: 'informationConfiguration',
    element: createLazyElement(async () => await import('@/pages/ArticlePublished')),
    name: '文章发布',
    breadCrumb: [
      // {
      //   title: '信息配置',
      //   href: `${BASE_PATH}/informationConfiguration`
      // },
      {
        title: '信息配置 / 文章发布',
        href: `${BASE_PATH}/articlePublished`
      }
    ]
  },
  {
    id: 'pushConfig',
    path: 'pushConfig',
    parentId: 'informationConfiguration',
    element: createLazyElement(async () => await import('@/pages/PushConfig/index')),
    name: '推送配置',
    breadCrumb: [
      {
        title: '信息配置 / 推送配置',
        href: `${BASE_PATH}/pushConfig`
      }
    ]
  },
  {
    id: 'addPushConfig',
    path: 'addPushConfig',
    menu: false,
    name: '新增推送配置',
    element: createLazyElement(async () => await import('@/pages/PushConfig/addPushConfig')),
    breadCrumb: [
      {
        title: '信息配置 / 推送配置',
        href: `${BASE_PATH}/pushConfig`
      }
    ]
  },
  {
    id: 'editPushConfig',
    path: 'editPushConfig',
    menu: false,
    name: '编辑推送配置',
    element: createLazyElement(async () => await import('@/pages/PushConfig/editPushConfig')),
    breadCrumb: [
      {
        title: '信息配置 / 推送配置',
        href: `${BASE_PATH}/pushConfig`
      }
    ]
  },
  {
    id: 'infoPushConfig',
    path: 'infoPushConfig',
    menu: false,
    name: '查看推送配置',
    element: createLazyElement(async () => await import('@/pages/PushConfig/infoPushConfig')),
    breadCrumb: [
      {
        title: '信息配置 / 推送配置',
        href: `${BASE_PATH}/pushConfig`
      }
    ]
  },
  // {
  //   id: 'mailInfoConfig',
  //   path: 'mailInfoConfig',
  //   parentId: 'informationConfiguration',
  //   element: createLazyElement(async () => await import('@/pages/MailInfoConfig/index')),
  //   name: '邮箱信息配置',
  //   breadCrumb: [
  //     {
  //       title: '邮箱信息配置',
  //       href: `${BASE_PATH}/mailInfoConfig`
  //     }
  //   ]
  // },
  // {
  //   id: 'addMailInfo',
  //   path: 'addMailInfo',
  //   name: '新增邮箱信息',
  //   menu: false,
  //   element: createLazyElementWithProps(
  //     async () => await import('@/pages/MailInfoConfig/addMailInfo'),
  //     { isEdit: true } // 传递参数
  //   )
  // },
  {
    id: 'withdrawMessageConfigList',
    path: 'withdrawMessageConfigList',
    parentId: 'informationConfiguration',
    element: createLazyElement(async () => await import('@/pages/WithdrawMessageConfigList/index')),
    name: '取现配置',
    breadCrumb: [
      {
        title: '信息配置 / 取现配置',
        href: `${BASE_PATH}/withdrawMessageConfigList`
      }
    ]
  },
  {
    id: 'withdrawMessageConfigStore',
    path: 'withdrawMessageConfigStore',
    parentId: 'informationConfiguration',
    name: '取现配置',
    menu: false,
    element: createLazyElementWithProps(
      async () => await import('@/pages/WithdrawMessageConfigStore/index'),
      { isEdit: true } // 传递参数
    )
  },
  {
    id: 'systemManagement',
    path: 'systemManagement',
    name: '系统管理',
    icon: <TeamOutlined />
  },
  {
    id: 'systemRbac',
    path: 'systemRbac',
    parentId: 'systemManagement',
    element: createLazyElement(async () => await import('@/pages/SystemRbac/index')),
    name: '用户与角色',
    breadCrumb: [
      {
        title: '系统管理 / 用户与角色',
        href: `${BASE_PATH}/systemManagement/systemRbac`
      }
    ]
  },
  {
    id: 'operationLog',
    path: 'operationLog',
    element: createLazyElement(async () => await import('@/pages/OperationLog')),
    name: '操作日志',
    icon: <ScheduleOutlined />,
    breadCrumb: [
      {
        title: '操作日志',
        href: `${BASE_PATH}/operationLog`
      }
    ]
  },
  {
    id: 'versionReleaseCenter',
    path: 'versionReleaseCenter',
    name: '版本发布中心',
    icon: <HistoryOutlined />,
    element: createLazyElement(async () => await import('@/pages/VersionReleaseCenter')),
    breadCrumb: [
      {
        title: '版本发布中心',
        href: `${BASE_PATH}/versionReleaseCenter`
      }
    ]
  }
]
